import { Footer } from '@xsite-ui/common.footer';
import hydrate from '@xsite-ui/partial-hydration/hydrate';
import { PrequalFunnelLayout } from '@xsite-ui/prequal-funnels.prequal-funnel-layout';

(() => {
  hydrate([PrequalFunnelLayout, Footer], {});
})();

export {};
